"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-gift-card-order.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-gift-card-order.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.giftCardProcessorToJSON = exports.giftCardProcessorFromJSON = exports.IncommSettlement = exports.GiftCardSettlement = exports.GiftCardOrderDetails = exports.GiftCardOrderPaymentContext = exports.GiftCardProcessor = void 0;
const amount_1 = require("../common/amount");
const gift_card_order_reversal_context_1 = require("./gift-card-order-reversal-context");
const gift_card_purchase_type_1 = require("./gift-card-purchase-type");
const protobufPackage = 'com.step.common.proto';
var GiftCardProcessor;
(function (GiftCardProcessor) {
    GiftCardProcessor["INVALID_GIFT_CARD_PROCESSOR"] = "INVALID_GIFT_CARD_PROCESSOR";
    GiftCardProcessor["ALDER_INCOMM"] = "ALDER_INCOMM";
    GiftCardProcessor["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GiftCardProcessor || (exports.GiftCardProcessor = GiftCardProcessor = {}));
function createBaseGiftCardOrderPaymentContext() {
    return {
        giftCardId: '',
        processor: GiftCardProcessor.INVALID_GIFT_CARD_PROCESSOR,
        reversal: undefined,
        purchaseType: gift_card_purchase_type_1.GiftCardPurchaseType.INVALID_GIFT_CARD_PURCHASE_TYPE,
        orderDetails: undefined,
        settlement: undefined,
    };
}
exports.GiftCardOrderPaymentContext = {
    fromJSON(object) {
        const message = {
            giftCardId: isSet(object.giftCardId) ? globalThis.String(object.giftCardId) : '',
            processor: isSet(object.processor)
                ? giftCardProcessorFromJSON(object.processor)
                : GiftCardProcessor.INVALID_GIFT_CARD_PROCESSOR,
        };
        if (isSet(object.reversal)) {
            message.reversal = gift_card_order_reversal_context_1.GiftCardOrderReversalContext.fromJSON(object.reversal);
        }
        if (isSet(object.purchaseType)) {
            message.purchaseType = (0, gift_card_purchase_type_1.giftCardPurchaseTypeFromJSON)(object.purchaseType);
        }
        if (isSet(object.orderDetails)) {
            message.orderDetails = exports.GiftCardOrderDetails.fromJSON(object.orderDetails);
        }
        if (isSet(object.settlement)) {
            message.settlement = exports.GiftCardSettlement.fromJSON(object.settlement);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.giftCardId !== '') {
            obj.giftCardId = message.giftCardId;
        }
        if (message.processor !== GiftCardProcessor.INVALID_GIFT_CARD_PROCESSOR) {
            obj.processor = giftCardProcessorToJSON(message.processor);
        }
        if (message.reversal !== undefined) {
            obj.reversal = gift_card_order_reversal_context_1.GiftCardOrderReversalContext.toJSON(message.reversal);
        }
        if (message.purchaseType !== undefined &&
            message.purchaseType !== gift_card_purchase_type_1.GiftCardPurchaseType.INVALID_GIFT_CARD_PURCHASE_TYPE) {
            obj.purchaseType = (0, gift_card_purchase_type_1.giftCardPurchaseTypeToJSON)(message.purchaseType);
        }
        if (message.orderDetails !== undefined) {
            obj.orderDetails = exports.GiftCardOrderDetails.toJSON(message.orderDetails);
        }
        if (message.settlement !== undefined) {
            obj.settlement = exports.GiftCardSettlement.toJSON(message.settlement);
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardOrderPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardOrderPaymentContext();
        message.giftCardId = object.giftCardId ?? '';
        message.processor = object.processor ?? GiftCardProcessor.INVALID_GIFT_CARD_PROCESSOR;
        message.reversal = (object.reversal !== undefined && object.reversal !== null)
            ? gift_card_order_reversal_context_1.GiftCardOrderReversalContext.fromPartial(object.reversal)
            : undefined;
        message.purchaseType = object.purchaseType ??
            gift_card_purchase_type_1.GiftCardPurchaseType.INVALID_GIFT_CARD_PURCHASE_TYPE;
        message.orderDetails = (object.orderDetails !== undefined && object.orderDetails !== null)
            ? exports.GiftCardOrderDetails.fromPartial(object.orderDetails)
            : undefined;
        message.settlement = (object.settlement !== undefined && object.settlement !== null)
            ? exports.GiftCardSettlement.fromPartial(object.settlement)
            : undefined;
        return message;
    },
};
function createBaseGiftCardOrderDetails() {
    return {
        orderCreatedAtMs: '0',
        productName: '',
        cardImageUrl: '',
        cardValue: amount_1.Amount.fromPartial({}),
    };
}
exports.GiftCardOrderDetails = {
    fromJSON(object) {
        const message = {
            orderCreatedAtMs: isSet(object.orderCreatedAtMs)
                ? globalThis.String(object.orderCreatedAtMs)
                : '0',
            productName: isSet(object.productName) ? globalThis.String(object.productName) : '',
            cardImageUrl: isSet(object.cardImageUrl) ? globalThis.String(object.cardImageUrl) : '',
            cardValue: isSet(object.cardValue)
                ? amount_1.Amount.fromJSON(object.cardValue)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderCreatedAtMs !== '0') {
            obj.orderCreatedAtMs = message.orderCreatedAtMs;
        }
        if (message.productName !== '') {
            obj.productName = message.productName;
        }
        if (message.cardImageUrl !== '') {
            obj.cardImageUrl = message.cardImageUrl;
        }
        if (message.cardValue !== undefined) {
            obj.cardValue = amount_1.Amount.toJSON(message.cardValue);
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardOrderDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardOrderDetails();
        message.orderCreatedAtMs = object.orderCreatedAtMs ?? '0';
        message.productName = object.productName ?? '';
        message.cardImageUrl = object.cardImageUrl ?? '';
        message.cardValue = (object.cardValue !== undefined && object.cardValue !== null)
            ? amount_1.Amount.fromPartial(object.cardValue)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseGiftCardSettlement() {
    return { incomm: undefined };
}
exports.GiftCardSettlement = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.incomm)) {
            message.incomm = exports.IncommSettlement.fromJSON(object.incomm);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.incomm !== undefined) {
            obj.incomm = exports.IncommSettlement.toJSON(message.incomm);
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardSettlement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardSettlement();
        message.incomm = (object.incomm !== undefined && object.incomm !== null)
            ? exports.IncommSettlement.fromPartial(object.incomm)
            : undefined;
        return message;
    },
};
function createBaseIncommSettlement() {
    return {
        invoiceId: '',
        merchantName: '',
        merchantId: '',
        productFee: amount_1.Amount.fromPartial({}),
        serviceFee: amount_1.Amount.fromPartial({}),
        faceValue: amount_1.Amount.fromPartial({}),
    };
}
exports.IncommSettlement = {
    fromJSON(object) {
        const message = {
            invoiceId: isSet(object.invoiceId) ? globalThis.String(object.invoiceId) : '',
            merchantName: isSet(object.merchantName) ? globalThis.String(object.merchantName) : '',
            merchantId: isSet(object.merchantId) ? globalThis.String(object.merchantId) : '',
            productFee: isSet(object.productFee)
                ? amount_1.Amount.fromJSON(object.productFee)
                : amount_1.Amount.fromPartial({}),
            serviceFee: isSet(object.serviceFee)
                ? amount_1.Amount.fromJSON(object.serviceFee)
                : amount_1.Amount.fromPartial({}),
            faceValue: isSet(object.faceValue)
                ? amount_1.Amount.fromJSON(object.faceValue)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.invoiceId !== '') {
            obj.invoiceId = message.invoiceId;
        }
        if (message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        if (message.merchantId !== '') {
            obj.merchantId = message.merchantId;
        }
        if (message.productFee !== undefined) {
            obj.productFee = amount_1.Amount.toJSON(message.productFee);
        }
        if (message.serviceFee !== undefined) {
            obj.serviceFee = amount_1.Amount.toJSON(message.serviceFee);
        }
        if (message.faceValue !== undefined) {
            obj.faceValue = amount_1.Amount.toJSON(message.faceValue);
        }
        return obj;
    },
    create(base) {
        return exports.IncommSettlement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIncommSettlement();
        message.invoiceId = object.invoiceId ?? '';
        message.merchantName = object.merchantName ?? '';
        message.merchantId = object.merchantId ?? '';
        message.productFee = (object.productFee !== undefined && object.productFee !== null)
            ? amount_1.Amount.fromPartial(object.productFee)
            : amount_1.Amount.fromPartial({});
        message.serviceFee = (object.serviceFee !== undefined && object.serviceFee !== null)
            ? amount_1.Amount.fromPartial(object.serviceFee)
            : amount_1.Amount.fromPartial({});
        message.faceValue = (object.faceValue !== undefined && object.faceValue !== null)
            ? amount_1.Amount.fromPartial(object.faceValue)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function giftCardProcessorFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_GIFT_CARD_PROCESSOR':
            return GiftCardProcessor.INVALID_GIFT_CARD_PROCESSOR;
        case 1:
        case 'ALDER_INCOMM':
            return GiftCardProcessor.ALDER_INCOMM;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return GiftCardProcessor.UNRECOGNIZED;
    }
}
exports.giftCardProcessorFromJSON = giftCardProcessorFromJSON;
function giftCardProcessorToJSON(object) {
    switch (object) {
        case GiftCardProcessor.INVALID_GIFT_CARD_PROCESSOR:
            return 'INVALID_GIFT_CARD_PROCESSOR';
        case GiftCardProcessor.ALDER_INCOMM:
            return 'ALDER_INCOMM';
        case GiftCardProcessor.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.giftCardProcessorToJSON = giftCardProcessorToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-gift-card-order.js.map